import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { AppComponent } from '../../app.component';
import { DataService } from '../../services/DataService';
import { ConfigService } from '../../models/ConfigService';

@Component({
    selector: 'rebar-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})



export class HomeComponent implements OnInit {	
	auth_token ="token";
	username ="user";
	constructor(private authService: MsalService,
		private msalBroadcastService: MsalBroadcastService,
		private app: AppComponent,
		private api: DataService,
		private conf : ConfigService
		) { }

	ngOnInit(): void {
		console.log('Home page intial')
		var formData: any = new FormData();
		this.msalBroadcastService.msalSubject$
			.pipe(
				filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS  || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
			)
			.subscribe((result: EventMessage) => {
				let RecivedToken = <AuthenticationResult["accessToken"]>result.payload;
				 window.sessionStorage.setItem("accessToken",RecivedToken);
				 this.auth_token = this.returnToken();
				 formData.append("auth_token", this.auth_token);
				 formData.append("username", this.authService.instance.getAllAccounts()[0].name);
				 console.log(this.auth_token)
				 console.log(this.authService.instance.getAllAccounts()[0].name)

				
			});

			this.api.InsertUser(this.auth_token,formData).subscribe(
				// this.api.GetDataForWordcloud(auth_token, this.form.get('SelTopWords')?.value, this.form.get('SelWordFrequency')?.value, this.form.get('SelNgrams')?.value, this.form.get('SelTextAnalysis')?.value, "", formData, this.username).subscribe(
				 //this.api.GetDataForWordcloud(auth_token, this.SelTopWords, this.SelWordFrequency, this.SelNgrams, this.SelTextAnalysis, "", this.uploadedFileName, this.username).subscribe(
				  (result: any) => {
					console.log('User inserted')

				  }
			)

			
	}
	
	returnToken()
	{
	  let tmp = this.authService.instance.getAllAccounts()[0]
	  let homeAccountID = tmp.homeAccountId  + "-" + tmp.environment + this.conf.getSettings("combinekey")  
	  
	  return homeAccountID;
	}
	

	ShowStasticalDiv(e: any) {
		this.app.ShowDiv('Segment');
	}

	ShowNumericalDiv(e: any) {
		this.app.ShowDiv('Charts');
	}

	ShowTextDiv(e:any){
		this.app.ShowDiv('TextAnalysis');
	}
}
